export const safeCatch = (fn, fallback = null) => {
  try {
    return fn();
  } catch (e) {
    return fallback;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/safeCatch.js